import AuthenticatedController from './AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import { MainMenuItemModel as MainMenuModel } from '../model/MainMenuModel';

export default class MainMenuController extends AuthenticatedController {
  static async getAll(
    botId: number,
    pageId?: number,
  ): Promise<MainMenuModel[]> {
    let response;
    if (pageId) {
      response = await super.get(APIRoutes.MAIN_MENU(botId), {
        page_id: pageId,
      });
    } else {
      response = await super.get(APIRoutes.MAIN_MENU(botId));
    }
    return response.mainMenuItems;
  }

  static async postMainMenu(
    botId: number,
    entity: Omit<MainMenuModel, 'id'>,
  ): Promise<MainMenuModel> {
    const response = await super.post(APIRoutes.MAIN_MENU(botId), entity);
    return response.mainMenuItem;
  }

  static async putMainMenu(
    botId: number,
    entity: MainMenuModel,
  ): Promise<MainMenuModel> {
    const response = await super.put(
      `${APIRoutes.MAIN_MENU(botId)}/${entity.id}`,
      entity,
    );
    return response.mainMenuItem;
  }

  static async deleteMainMenu(
    botId: number,
    entityId: number,
    pageId: number | null,
  ): Promise<any> {
    const q = pageId ? `?page_id=${pageId}` : '';
    return super.delete(`${APIRoutes.MAIN_MENU(botId)}/${entityId}${q}`);
  }
}
